import { render, staticRenderFns } from "./FormattedDateComponent.vue?vue&type=template&id=307c2514&scoped=true&"
import script from "./FormattedDateComponent.vue?vue&type=script&lang=js&"
export * from "./FormattedDateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307c2514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307c2514')) {
      api.createRecord('307c2514', component.options)
    } else {
      api.reload('307c2514', component.options)
    }
    module.hot.accept("./FormattedDateComponent.vue?vue&type=template&id=307c2514&scoped=true&", function () {
      api.rerender('307c2514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formatted/FormattedDateComponent.vue"
export default component.exports